<template>
    <div class="content">
        <template v-if="editor">
            <ckeditor :editor="editor" v-model="ckValue" :config="editorConfig" @input="change"></ckeditor>
        </template>
    </div>
</template>
<script>
import CKEditor from '@ckeditor/ckeditor5-vue2';

export default {
    name: 'FormWysiwyg',
    components: {
        ckeditor: CKEditor.component,
    },
    props: ['value', 'disabled', 'maxlength'],
    data() {
        return {
            ckValue: '',
            editorConfig: null,
            editor: null,
            isLoading: false,
        };
    },
    watch: {
        value() {
            this.handleValue();
        },
    },
    created() {
        this.handleValue();
    },
    async mounted() {
        this.isLoading = true;
        // Dynamically import CKEditor only when the component is mounted
        const {
            AutoLink,
            Alignment,
            Bold,
            Essentials,
            FontColor,
            Heading,
            Highlight,
            Indent,
            IndentBlock,
            Italic,
            Link,
            List,
            ListProperties,
            Paragraph,
            RemoveFormat,
            Strikethrough,
            Superscript,
            Underline,
            Table,
            TableCellProperties,
            TableColumnResize,
            TableProperties,
            TableToolbar,
            Undo,
            /*Base64UploadAdapter,
    AutoImage,
    ImageBlock,
    ImageInline,
    ImageInsert,
    ImageInsertViaUrl,
    ImageResize,
    ImageStyle,
    ImageToolbar,
    ImageUpload,*/

            ClassicEditor,
        } = await System.import('ckeditor5');

        this.editorConfig = {
            toolbar: {
                items: [
                    'undo',
                    'redo',
                    '|',
                    'heading',
                    '|',
                    'fontColor',
                    '|',
                    'bold',
                    'italic',
                    'underline',
                    'strikethrough',
                    'superscript',
                    'removeFormat',
                    '|',
                    'link',
                    'highlight',
                    '|',
                    'alignment',
                    '|',
                    '|',
                    'bulletedList',
                    'numberedList',
                    'indent',
                    'outdent',
                    '|',
                    'insertTable',
                    //'insertImage',
                ],
                shouldNotGroupWhenFull: true,
            },
            plugins: [
                AutoLink,
                Alignment,
                Bold,
                Essentials,
                FontColor,
                Heading,
                Highlight,
                Indent,
                IndentBlock,
                Italic,
                Link,
                List,
                ListProperties,
                Paragraph,
                RemoveFormat,
                Strikethrough,
                Superscript,
                Underline,
                Table,
                TableCellProperties,
                TableColumnResize,
                TableProperties,
                TableToolbar,
                Undo,
                /*Base64UploadAdapter,
            AutoImage,
            ImageBlock,
            ImageInline,
            ImageInsert,
            ImageInsertViaUrl,
            ImageResize,
            ImageStyle,
            ImageToolbar,
            ImageUpload,*/
            ],
            list: {
                properties: {
                    styles: true,
                    startIndex: false,
                    reversed: false,
                },
            },
            table: {
                contentToolbar: [
                    'tableColumn',
                    'tableRow',
                    'mergeTableCells',
                    'tableProperties',
                    'tableCellProperties',
                ],
            },
            image: {
                toolbar: [
                    'imageTextAlternative',
                    '|',
                    'imageStyle:inline',
                    'imageStyle:wrapText',
                    'imageStyle:breakText',
                    '|',
                    'resizeImage',
                ],
            },
            //placeholder: this.$t('text.startWriting'),
        };
        this.editor = ClassicEditor;
        this.isLoading = false;
    },
    methods: {
        handleValue() {
            if (this.value) {
                this.ckValue = this.value;
            } else {
                this.ckValue = '';
            }
        },
        change(value) {
            this.$emit('input', value);
        },
    },
};
</script>
<style>
@import 'https://cdn.ckeditor.com/ckeditor5/43.1.0/ckeditor5.css';
</style>
